
  document.addEventListener('DOMContentLoaded', function (){ 
    
    var collectionSwatch = function() {
      $(document).on('click', '.custom_collection_swatches a.swatch', function(e) {
        e.preventDefault();
         $(this).parent().find('a.swatch').removeClass('selected-swatch');
         $(this).addClass('selected-swatch');
        var variantImg = $(this).data("image");
        var title = $(this).data('title');
        $(this).parents('.product-item').find('.custom_option_title').html(title);
        if($(this).data("image").indexOf("no-image") == -1) {  
          $(this).parents('.product-item').find('.product-item__bg > figure.image-wrapper img').attr('src', variantImg);
          $(this).parents('.product-item').find('.product-item__bg > figure.image-wrapper img').attr('srcset', variantImg);
        } 
      }); 
    };
    var videoPlay = function() {
      $(document).on('click', '.videoPlay', function(e) {
        e.preventDefault();
        $(this).parent().addClass('active');
        if($(this).parent().find(".video_iframe_yt").length > 0){
          $(this).parent().find(".video_iframe_yt")[0].src += "&autoplay=1";
        }
        if($(this).parent().find("video").length > 0){
          $(this).parent().find(".ctm_video")[0].play();
        }
      });
      
      $(document).on('click', '.vid-play', function(e) {
        e.preventDefault();
         $(this).hide();
        $(this).parent().find('.vid-pause').css('display','block');
         $(this).parents('.videoWrapper').find("video").get(0).play();
      });
      $(document).on('click', '.vid-pause', function(e) {
        e.preventDefault();
        $(this).hide();
         $(this).parent().find('.vid-play').css('display','block');
         $(this).parents('.videoWrapper').find("video").get(0).pause();
      });
      
      $(document).on('click', '.vid-unmute', function(e) {
        e.preventDefault();
         $(this).hide();
        $(this).parent().find('.vid-mute').css('display','block');
         $(this).parents('.videoWrapper').find("video").prop('muted', false)
      });
      $(document).on('click', '.vid-mute', function(e) {
        e.preventDefault();
        $(this).hide();
         $(this).parent().find('.vid-unmute').css('display','block');
         $(this).parents('.videoWrapper').find("video").prop('muted', true)
      });
    };

    collectionSwatch();
    videoPlay();    
    document.querySelectorAll('[data-option-metal]').forEach(item=>{
      item.addEventListener('click',function(){
          if(this.closest('popout-select')){
              this.closest('popout-select').querySelector('button.select-popout__toggle [data-option-metal]').setAttribute('data-option-metal',this.getAttribute('data-option-metal'))
          }
      })
    })
  }, false);

